<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';

export default {
  components: {
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
      }),
      require: true,
    },

  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  setup() {
    return {
      // Filter
      avatarText,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <div>
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Contribuinte ICMS"
                label-for="clientecontribuinteicms"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.clientecontribuinteicms"
                    id="clientecontribuinteicms"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Simples Nacional"
                label-for="clientesimplesnacional"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.clientesimplesnacional"
                    id="clientesimplesnacional"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Natur. Oper. Interna"
                label-for="clientenatoperinterna"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientenatoperinterna"
                    id="clientenatoperinterna"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Natur. Oper. Externa"
                label-for="clientenatoperexterna"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clientenatoperexterna"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientenatoperexterna"
                    id="clientenatoperexterna"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                    disabled
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Observação Fiscal"
                label-for="clienteobservacaofiscal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Responsavel"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.clienteobservacaofiscal"
                    id="clienteobservacaofiscal"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Observação Fiscal"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </div>
  </validation-observer>

</template>
